const FORMULA_PREFIX_RE = /^[=+\-@]/;

export const escapeCsvCell = (value) => {
  const normalizedValue = value == null ? '' : String(value);
  const escapedValue = normalizedValue.replace(/"/g, '""');
  const formulaSafeValue = FORMULA_PREFIX_RE.test(escapedValue)
    ? `'${escapedValue}`
    : escapedValue;

  return `"${formulaSafeValue}"`;
};
